import { AnsibleBoolean } from '../interfaces/ansible-config';
import { TeamSettingsService } from './team-settings.service';


declare const __ACTIVATION_DEPRICATION_CONFIG__;

export let _activationStatusService: ActivationStatusService;

export class ActivationStatusService {
  static deps = [TeamSettingsService];

  constructor(
    private _teamSettingsService: TeamSettingsService,
  ) {
    _activationStatusService = this;
  }

  /**
   * Activate 2.0 teams are shown the menu regardless of the 1.0 sunset config: `disabled` is the
   * *Activate 1.0* deprecation switch, and gating 2.0 on it makes the two flags unsatisfiable
   * together — the team-settings API only reports `h2_activation_enabled` for a team that is NOT
   * `activate_enabled`, which is exactly the team the sunset branch below hides the menu from.
   */
  shouldShowActivation() {
    return this._teamSettingsService.isH2ActivationEnabled() ||
    __ACTIVATION_DEPRICATION_CONFIG__.disabled === AnsibleBoolean.FALSE ||
    (__ACTIVATION_DEPRICATION_CONFIG__.disabled === AnsibleBoolean.TRUE && this._teamSettingsService.isActivationEnabled());
  }

  // SHOULD BE CLEANED UP AFTER SUNSET
  shouldShowActivationBanner() {
    return __ACTIVATION_DEPRICATION_CONFIG__.disabled === AnsibleBoolean.TRUE &&
    __ACTIVATION_DEPRICATION_CONFIG__.showBanner === AnsibleBoolean.TRUE;
  }

  getActivationSunsetEpoch() {
    return __ACTIVATION_DEPRICATION_CONFIG__.activateSunsetEpoch;
  }

}
